<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>
    </div>
</template>


<script>
import amplitude from '../util/analytics/amplitude';


const CLASSIC_LINKS = [
    {
        id: 1,
        link: 'https://help.infusionsoft.com/help/list-hygiene',
        label: 'Clean your email lists',
    },
    {
        id: 2,
        link: 'https://keap.com/business-success-blog/marketing/email-marketing/building-email-reputation',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
    {
        id: 4,
        link: '/app/miscSetting/itemWrapper?systemId=nav.marketing&settingModuleName=Marketing&settingTabName=email.addressstatus.limits.title',
        label: 'Set List Automation',
    },
];

const KEAP_LINKS = [
    {
        id: 1,
        link: 'https://help.keap.com/help/list-hygiene',
        label: 'Clean your email lists',
    },
    {
        id: 2,
        link: 'https://keap.com/business-success-blog/marketing/email-marketing/building-email-reputation',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://help.keap.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
];


export default {
    props: {
        isUnengagedEmailStatusProcessingEnabled: Boolean,
        appEdition: String,
    },
    computed: {
        icon() {
            return 'circle';
        },
        showSetListManagementCallToAction() {
            return Boolean(this.isUnengagedEmailStatusProcessingEnabled);
        },
        listItems() {
            if (this.appEdition === 'Keap Max Classic Edition') {
                return CLASSIC_LINKS;
            }

            return KEAP_LINKS;
        },
    },
    methods: {
        handleClick(object) {
            window.open(object.link, '_blank');

            this.emitAmplitudeEvent(object.label);
        },
        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Bounce Page',
                Destination: event,
            });
        },

    },
};

</script>

<style lang="scss" scoped>

#leadingSlot {
    padding: 0;
}

.list-item-description {
    font-size: $font-size-md;
    padding-right: $spacing-200;
}

.row {
    display: flex;
}

.column-left {
    flex: 50%;
    float: left;
}

.column-right {
    flex: 50%;
    text-align: right;
}

</style>
